import {
  ROOT, GET_ALL_CHAIN,
  GET_DETAIL_HOTEL_CHAIN,
  CHAIN_BOOKING_GET_ALL,
  CHAIN_BOOKING_DETAIL,
  BOOKING_EXPORT_CHAIN,
  GET_CHAIN_INFO,
  UPDATE_CHAIN_INFO,
  GET_CHAIN_TYPE,
  GET_ALL_TRAVEL_AGENT,
  REMOVE_TRAVEL_AGENT,
  GET_CHAIN_TRAVEL_AGENT_INFO,
  GET_HOTE_BY_CHAIN,
  UPDATE_AGENT_CHAIN,
  CREATE_AGENT_CHAIN,
  GET_ALL_ROOM_CHAIN,
  GET_DETAIL_ROOM_CHAIN,
  GET_ALL_RATE_PLAN_CHAIN,
  GET_RATE_PLAN_CHAIN_DETAIL,
  CREATE_RATE_PLAN_CHAIN,
  UPDATE_RATE_PLAN_CHAIN,
  UPDATE_STATUS_RATE_PLAN_CHAIN,
  DELETE_RATE_PLAN_CHAIN,
  CREATE_ROOM_CHAIN,
  UPDATE_ROOM_CHAIN,
  UPDATE_AMENITIES_ROOM_CHAIN,
  UPDATE_STATUS_ROOM_CHAIN,
  DELETE_ROOM_CHAIN,
  GET_COUNTRY,
  UPDATE_STATUS_AGENT_CHAIN,
  UPLOAD_IMAGE_RESOURCE,
  DELETE_IMAGE_RESOURCE,
  GET_HOTEL_LIST_BY_CHAIN_LIST,
  RE_SYNC_CHAIN,
  GET_TOTAL_BOOKINGS_GROUP_BY_HOTEL,
  GET_AL_BOOKINGS_GROUP_BY_HOTEL,
  EXPORT_BOOKINGS_GROUP_BY_HOTEL,
  GET_OTA_BY_CHAIN,
  UPDATE_RATE_BY_OTA,
  ALL_LOGS_CHAIN,
  GET_ALL_OTA_ASSIGN,
  GET_OTA_ASSIGN,
  RE_SYNCS_CHAIN,
  EXPORT_PDF_BOOKINGS_GROUP_BY_HOTEL,
  GET_ROOM_TYPE_BY_CHAIN,
  GET_ALL_CHAIN_SEGMENT,
  GET_RATE_PLAN_BY_CHAIN,
  GET_ALL_OTA_BY_CHAIN,
  GET_VERSION,
  GET_LIST_LANGS
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";


function getAllSegment() {
  return fetch(ROOT + GET_ALL_CHAIN_SEGMENT, requestOptions.get()).then(handleResponse);
}

//#region list of hotel
function get(params) {
  return fetch(ROOT + GET_ALL_CHAIN, requestOptions.post(params)).then(handleResponse);
}
function useHotel(hotelId) {
  return fetch(ROOT + GET_DETAIL_HOTEL_CHAIN + `/${hotelId}`, requestOptions.get()).then(
    handleResponse
  );
}
function getAllBooking(params) {
  return fetch(ROOT + CHAIN_BOOKING_GET_ALL, requestOptions.post(params))
    .then(handleResponse);
}

function getBookingDetail(code) {
  return fetch(ROOT + CHAIN_BOOKING_DETAIL + `/` + code, requestOptions.get())
    .then(handleResponse);
}

function exportBooking(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + BOOKING_EXPORT_CHAIN, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function getChainInfo() {
  return fetch(ROOT + GET_CHAIN_INFO, requestOptions.post()).then(handleResponse);
}
function updateChainInfo(body) {
  return fetch(ROOT + UPDATE_CHAIN_INFO, requestOptions.post(body)).then(handleResponse);
}
function getChainType() {
  return fetch(ROOT + GET_CHAIN_TYPE, requestOptions.get()).then(handleResponse);
}

function getAllTravelAgent(body) {
  return fetch(ROOT + GET_ALL_TRAVEL_AGENT, requestOptions.post(body)).then(handleResponse);
}

function removeAgent(body) {
  return fetch(ROOT + REMOVE_TRAVEL_AGENT + `?id=${body}`, requestOptions.post()).then(handleResponse);
}

function getChainTravelAgentInfo(body) {
  return fetch(ROOT + GET_CHAIN_TRAVEL_AGENT_INFO + `?id=${body}`, requestOptions.post()).then(handleResponse);
}

function getHotelByChain(data) {
  return fetch(ROOT + GET_HOTE_BY_CHAIN + `?lang=${data}`, requestOptions.get()).then(handleResponse);
}

function updateAgent(data) {
  return fetch(ROOT + UPDATE_AGENT_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function createAgent(data) {
  return fetch(ROOT + CREATE_AGENT_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function getAllRooms(data) {
  return fetch(ROOT + GET_ALL_ROOM_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function getRoomDetail(data) {
  return fetch(ROOT + GET_DETAIL_ROOM_CHAIN + `/${data}`, requestOptions.get()).then(handleResponse);
}

function getAllRatePlanChain(data) {
  return fetch(ROOT + GET_ALL_RATE_PLAN_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function getRatePlanDetail(data) {
  return fetch(ROOT + GET_RATE_PLAN_CHAIN_DETAIL + `/${data}`, requestOptions.get()).then(handleResponse);
}

function updateRoom(data) {
  return fetch(ROOT + UPDATE_ROOM_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function createRoom(data) {
  return fetch(ROOT + CREATE_ROOM_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function updateRate(data) {
  return fetch(ROOT + UPDATE_RATE_PLAN_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function createRate(data) {
  return fetch(ROOT + CREATE_RATE_PLAN_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function updateSalePackageStatus(data) {
  return fetch(ROOT + UPDATE_STATUS_RATE_PLAN_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function removeRatePlan(data) {
  return fetch(ROOT + DELETE_RATE_PLAN_CHAIN + `/${data}`, requestOptions.get()).then(handleResponse);
}

function updateRoomAmenities(id, data) {
  return fetch(ROOT + UPDATE_AMENITIES_ROOM_CHAIN + `/${id}`, requestOptions.post(data)).then(handleResponse);
}

function removeRoom(data) {
  return fetch(ROOT + DELETE_ROOM_CHAIN + `/${data}`, requestOptions.get()).then(handleResponse);
}

function updateRoomStatus(data) {
  return fetch(ROOT + UPDATE_STATUS_ROOM_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function getCountry(data) {
  return fetch(ROOT + GET_COUNTRY + `?lang=${data}`, requestOptions.get()).then(handleResponse);
}


function updateStatus(data) {
  return fetch(ROOT + UPDATE_STATUS_AGENT_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function uploadImage(data) {
  let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
  let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
  return fetch(ROOT + UPLOAD_IMAGE_RESOURCE, {
    method: "POST",
    body: data,
    headers: {
      Authorization: authHeader.Authorization
    }
  })
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}

function removeImage(id) {
  return fetch(ROOT + DELETE_IMAGE_RESOURCE + `/${id}`, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      return data;
    });
}

function getHotelListByChainList(data) {
  return fetch(ROOT + GET_HOTEL_LIST_BY_CHAIN_LIST, requestOptions.post(data)).then(handleResponse);
}

function reSync(data) {
  return fetch(ROOT + RE_SYNC_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function reSyncs(data) {
  return fetch(ROOT + RE_SYNCS_CHAIN, requestOptions.post(data)).then(handleResponse);
}

function getTotalBookingsGroupByHotel(data) {
  return fetch(ROOT + GET_TOTAL_BOOKINGS_GROUP_BY_HOTEL, requestOptions.post(data)).then(handleResponse);
}

function getAllBookingsGroupByHotel(data) {
  return fetch(ROOT + GET_AL_BOOKINGS_GROUP_BY_HOTEL, requestOptions.post(data)).then(handleResponse);
}

function exportExcelBookingGroupByHotel(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + EXPORT_BOOKINGS_GROUP_BY_HOTEL, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}

function exportPdfBookingGroupByHotel(params) {
  let fileName = "temp.xlxs";
  return fetch(ROOT + EXPORT_PDF_BOOKINGS_GROUP_BY_HOTEL, requestOptions.post(params))
    .then(response => {
      fileName = response.headers.get('Content-Disposition').split("filename=")[1];
      return response.blob();
    })
    .then(blob => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
      a.click();
      a.remove();  //afterwards we remove the element again         
    });
}


function getAllOtaChain() {
  return fetch(ROOT + GET_OTA_BY_CHAIN, requestOptions.get())
    .then(handleResponse);
}
function getAllOtaByChain() {
  return fetch(ROOT + GET_ALL_OTA_BY_CHAIN, requestOptions.get())
    .then(handleResponse);
}
function updateRateOta(body) {
  return fetch(ROOT + UPDATE_RATE_BY_OTA, requestOptions.post(body))
    .then(handleResponse);
}

function getAllLogs(data) {
  return fetch(ROOT + ALL_LOGS_CHAIN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllOtaAssign(data) {
  return fetch(ROOT + GET_ALL_OTA_ASSIGN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getOtaAssign(data) {
  return fetch(ROOT + GET_OTA_ASSIGN, requestOptions.post(data))
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllRoomTypeByChain() {
  return fetch(ROOT + GET_ROOM_TYPE_BY_CHAIN, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}

function getAllRatePlanByChain() {
  return fetch(ROOT + GET_RATE_PLAN_BY_CHAIN, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
function getVersion() {
  return fetch(ROOT + GET_VERSION, requestOptions.get())
  .then(handleResponse)
  .then(data => {
    return data;
  });
}
function getListLangs() {
  return fetch(ROOT + GET_LIST_LANGS, requestOptions.get())
    .then(handleResponse)
    .then(data => {
      return data;
    });
}
//#endregion
export const chainService = {
  getAllOtaByChain,
  get,
  useHotel,
  getAllBooking,
  getBookingDetail,
  exportBooking,
  getChainInfo,
  updateChainInfo,
  getChainType,
  getAllTravelAgent,
  removeAgent,
  getChainTravelAgentInfo,
  getHotelByChain,
  updateAgent,
  createAgent,
  getAllRooms,
  getRoomDetail,
  getAllRatePlanChain,
  getRatePlanDetail,
  updateRate,
  createRate,
  updateSalePackageStatus,
  removeRatePlan,
  updateRoom,
  createRoom,
  updateRoomAmenities,
  updateRoomStatus,
  removeRoom,
  getCountry,
  updateStatus,
  uploadImage,
  removeImage,
  getHotelListByChainList,
  reSync,
  getTotalBookingsGroupByHotel,
  getAllBookingsGroupByHotel,
  exportExcelBookingGroupByHotel,
  getAllOtaChain,
  updateRateOta,
  getAllLogs,
  getAllOtaAssign,
  getOtaAssign,
  exportPdfBookingGroupByHotel,
  reSyncs,
  getAllRoomTypeByChain,
  getAllSegment,
  getAllRatePlanByChain,
  getVersion,
  getListLangs
};
